webpackJsonp([205888622327290],{

/***/ 604:
/***/ (function(module, exports) {

	module.exports = {"data":{"projectsJson":{"name":"ELC 360","keywords":["iOS","Swift","360","VR"],"status":["shipped","green"],"tagline":"A native iOS app for an Estee Lauder 360 campaign.","year":[2017],"description":"Estee Lauder had a **360 video** on Youtube that they needed to work offline for marketing purposes. I created an iOS app using the [Google VR SDK for iOS](https://developers.google.com/vr/ios/) to show the video in 360 or VR (with a Google Cardboard).\n\nThis was my first real foray into the native iOS world, and I went deep into the **Swift and Xcode** world to make this project happen.","images":["elc360.png-noShadow"],"videos":null,"id":"/Users/davidbaker/code/davidbaker.is/src/data/projects.json absPath of file [1] >>> JSON","logo":null,"link":null,"linkToSource":null,"linkToTrello":null,"callToAction":null,"teammates":null,"agency":{"name":"Click 3X","link":"http://click3x.com/"}}},"pathContext":{"projectPath":"a-vr-native-360-ios-swift-master"}}

/***/ })

});


// WEBPACK FOOTER //
// path---a-vr-native-360-ios-swift-master-41930f4a517936b5dd41.js